import type { AppRouteRecordRaw, AppRouteModule } from '@/router/types';
import {
    PAGE_NOT_FOUND_ROUTE,
    REDIRECT_ROUTE,
    SVG_PREVIEW,
    ANI_PREVIEW,
    EXPERIMENT,
} from '@/router/routes/basic';
import Home from './modules/home';
import { t } from '@/hooks/web/useI18n';

// 全局获取 modules 文件夹下的 ts 模块
const routeList = getRouterList('all');
export const asyncRoutes = [...routeList, PAGE_NOT_FOUND_ROUTE];

export const menuRouteList = [Home, ...getRouterList('menu')].sort(
    (a, b) => ((a.meta?.orderNo as any) || 0) - ((b.meta?.orderNo as any) || 0),
);

export const RootRoute: AppRouteRecordRaw = {
    path: '/',
    name: 'Root',
    redirect: '/home',
    meta: {
        title: 'Root',
    },
};

export const LoginRoute: AppRouteRecordRaw = {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/sys/login/Login.vue'),
    meta: {
        title: t('routes.index.login'),
    },
};

const devRoutes = import.meta.env.MODE === 'development' 
    ? [
        SVG_PREVIEW,
        ANI_PREVIEW,
        EXPERIMENT,
    ] 
    : []
// ...当前场景暂时没有任何权限，asyncRoutes 先直接放这里
export const basicRoutes = [
    LoginRoute,
    RootRoute,
    ...asyncRoutes,
    REDIRECT_ROUTE,
    ...devRoutes,
    PAGE_NOT_FOUND_ROUTE,
];

function getRouterList(path: string) {
    // import 不支持变量
    let modules: any;
    switch (path) {
        case 'all':
            modules = import.meta.glob('./modules/**/*.ts', { eager: true });
            break;
        case 'menu':
            modules = import.meta.glob('./modules/menu/*.ts', { eager: true });
            break;
        case 'tool':
            modules = import.meta.glob('./modules/main/tool.ts', { eager: true });
            break;
    }
    // const modules = import.meta.glob(path, { eager: true });
    const routeModuleList: AppRouteModule[] = [];

    Object.keys(modules).forEach((key) => {
        const mod = modules[key].default || {};
        const modList = Array.isArray(mod) ? [...mod] : [mod];
        routeModuleList.push(...modList);
    });

    return routeModuleList || [];
}

/**
 * 获取每个路由下的名字
 *
 */
function getPageName(route: AppRouteRecordRaw) {
    return route.children
        ? [...route.children.reduce((p, c) => [...p, ...getPageName(c)], [])]
        : [{ name: route.name, path: route.path }];
}

// const list = basicRoutes.reduce((p, c) => [...p, ...getPageName(c)], [])

export const PageEnum = basicRoutes
    .reduce((p, c) => [...p, ...getPageName(c)], [])
    .reduce((p, c) => ({ ...p, [c.name]: c.path }), {});
